// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================================
   DESIGN TOKENS — Pyate Blue Brand
====================================== */
:root {
  --brand:          #1565C0;
  --brand-mid:      #1976D2;
  --brand-light:    #42A5F5;
  --brand-soft:     #E3F2FD;
  --brand-glow:     rgba(21, 101, 192, 0.18);
  --orange:         #F4511E;
  --orange-deep:    #D84315;
  --orange-soft:    #FBE9E7;
  --orange-glow:    rgba(244, 81, 30, 0.24);
  --accent:         #00BCD4;
  --surface:        #ffffff;
  --surface-2:      #F8FAFC;
  --surface-3:      #EEF4FB;
  --bg:             #EEF4FB;
  --border:         #DBEAFE;
  --border-strong:  #BFDBFE;
  --text-primary:   #0D1B2A;
  --text-secondary: #3B5270;
  --text-muted:     #7A96B2;
  --danger:         #EF4444;
  --danger-soft:    #FEF2F2;
  --success:        #22C55E;
  --success-soft:   #DCFCE7;
  --font:           'Plus Jakarta Sans', sans-serif;
  --ease:           cubic-bezier(0.16, 1, 0.3, 1);
  --radius-sm:      8px;
  --radius-md:      14px;
  --radius-lg:      20px;
  --shadow-sm:      0 1px 4px rgba(21,101,192,0.07), 0 4px 14px rgba(21,101,192,0.05);
  --shadow-md:      0 4px 20px rgba(21,101,192,0.12), 0 12px 36px rgba(21,101,192,0.07);
  --shadow-lg:      0 8px 36px rgba(21,101,192,0.16), 0 28px 60px rgba(21,101,192,0.09);
}

* { box-sizing: border-box; }

/* ======================================
   CART PAGE WRAPPER
====================================== */
.cart {
  font-family: var(--font);
  max-width: 1200px;
  margin: 70px auto 60px;
  background: var(--bg);
  padding: 28px 20px 30px;
}

/* ======================================
   CART HEADER
====================================== */
.cart-header {
  background: var(--surface);
  padding: 14px 22px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  position: relative;
  overflow: hidden;
}

.cart-header::before {
  content: '';
  position: absolute;
  left: 0; top: 0; bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, var(--brand), var(--brand-light));
  border-radius: var(--radius-md) 0 0 var(--radius-md);
}

.cart-header h2 {
  font-size: 15px;
  font-weight: 800;
  color: var(--brand);
  margin: 0;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  padding-left: 6px;
}

.delivery-info {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: var(--text-muted);
  font-weight: 500;
}

/* ======================================
   LAYOUT
====================================== */
.cart-content {
  display: flex;
  gap: 18px;
  align-items: flex-start;
}

/* ======================================
   ITEMS PANEL
====================================== */
.cart-items-container {
  flex: 2 1;
  background: var(--surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}

.cart-full-message {
  background: #FFF8E1;
  color: #E65100;
  padding: 10px 20px;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  border-bottom: 1px solid #FFE0B2;
}

/* ======================================
   CART ITEM CARD
====================================== */
.cart-item-card {
  display: flex;
  padding: 20px 22px;
  border-bottom: 1px solid var(--border);
  position: relative;
  gap: 14px;
  align-items: flex-start;
  transition: background 0.18s;
}

.cart-item-card:last-child { border-bottom: none; }
.cart-item-card:hover { background: var(--surface-2); }

.item-selector {
  display: flex;
  align-items: flex-start;
  padding-top: 6px;
  flex-shrink: 0;
}

.item-selector input[type="checkbox"],
.item-selector input {
  width: 16px;
  height: 16px;
  accent-color: var(--brand);
  cursor: pointer;
}

.cart-item-image {
  width: 86px;
  height: 86px;
  object-fit: contain;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background: var(--surface-2);
  padding: 8px;
  flex-shrink: 0;
  transition: transform 0.22s var(--ease);
}

.cart-item-card:hover .cart-item-image { transform: scale(1.05); }

.cart-item-details {
  flex-grow: 1;
  padding-right: 80px;
  min-width: 0;
}

.cart-item-details h3 {
  font-size: 14.5px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 4px;
  line-height: 1.4;
}

.seller-info {
  font-size: 12px;
  color: var(--text-muted);
  margin-bottom: 8px;
  font-weight: 500;
}

.price-details {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 6px 0;
  flex-wrap: wrap;
}

.current-price {
  font-size: 16px;
  font-weight: 800;
  color: var(--text-primary);
  letter-spacing: -0.3px;
}

.original-price {
  font-size: 13px;
  color: var(--text-muted);
  text-decoration: line-through;
  margin-left: 4px;
}

.discount-percent {
  font-size: 12px;
  color: var(--success);
  font-weight: 700;
  background: var(--success-soft);
  padding: 2px 8px;
  border-radius: 100px;
}

.delivery-icon { font-size: 15px; }

.delivery-date {
  font-weight: 700;
  color: var(--brand);
}

/* ======================================
   QUANTITY CONTROLS
====================================== */
.quantity-controls {
  display: inline-flex;
  align-items: center;
  margin: 12px 0 0;
  border: 1.5px solid var(--border-strong);
  border-radius: 100px;
  overflow: hidden;
  background: var(--surface);
  box-shadow: var(--shadow-sm);
}

.quantity-controls button {
  background: transparent;
  border: none;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 17px;
  font-weight: 700;
  color: var(--brand);
  transition: background 0.15s;
  flex-shrink: 0;
}

.quantity-controls button:hover { background: var(--brand-soft); }

.quantity-controls span {
  width: 38px;
  height: 34px;
  border-left: 1.5px solid var(--border-strong);
  border-right: 1.5px solid var(--border-strong);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: var(--text-primary);
}

/* ======================================
   REMOVE BUTTON
====================================== */
.remove-button {
  position: absolute;
  right: 20px;
  top: 20px;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  cursor: pointer;
  background: transparent;
  border: 1.5px solid var(--border-strong);
  color: var(--text-muted);
  border-radius: 100px;
  padding: 4px 12px;
  transition: all 0.18s var(--ease);
}

.remove-button:hover {
  background: var(--danger-soft);
  border-color: #FECACA;
  color: var(--danger);
}

/* ======================================
   PRICE SUMMARY PANEL
====================================== */
.price-summary {
  flex: 1 1;
  background: var(--surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  padding: 20px;
  height: fit-content;
  position: sticky;
  top: 100px;
  overflow: hidden;
}

.price-summary::before {
  content: '';
  display: block;
  height: 4px;
  background: linear-gradient(90deg, var(--brand), var(--brand-light), var(--accent));
  margin: -20px -20px 18px;
}

.price-summary-header {
  font-size: 11px;
  font-weight: 800;
  color: var(--text-muted);
  letter-spacing: 1.2px;
  text-transform: uppercase;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 16px;
}

.price-detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 13px;
  font-size: 14px;
  color: var(--text-secondary);
  font-weight: 500;
}

.price-detail-row.total {
  font-weight: 800;
  font-size: 17px;
  color: var(--text-primary);
  padding-top: 14px;
  border-top: 1px dashed var(--border-strong);
  margin-top: 4px;
  letter-spacing: -0.3px;
}

.discount { color: var(--success); font-weight: 700; }
.free-delivery { color: var(--success); font-weight: 700; }

.savings-message {
  background: var(--success-soft);
  color: #15803D;
  font-size: 13px;
  font-weight: 700;
  padding: 10px 14px;
  border-radius: var(--radius-sm);
  margin: 14px 0;
  text-align: center;
}

/* ======================================
   COUPON SECTION
====================================== */
.coupon-section {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  align-items: center;
}

.coupon-section input[type="text"] {
  flex: 1 1;
  padding: 9px 14px;
  border: 1.5px solid var(--border-strong);
  border-radius: var(--radius-sm);
  font-family: var(--font);
  font-size: 13.5px;
  color: var(--text-primary);
  background: var(--surface-2);
  outline: none;
  min-width: 0;
  transition: border-color 0.18s, box-shadow 0.18s;
}

.coupon-section input[type="text"]:focus {
  border-color: var(--brand-mid);
  box-shadow: 0 0 0 3px var(--brand-soft);
  background: white;
}

.coupon-section button {
  padding: 9px 16px;
  background: var(--brand-soft);
  color: var(--brand);
  border: 1.5px solid var(--border-strong);
  border-radius: var(--radius-sm);
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  margin-top: 0;
  transition: all 0.18s var(--ease);
}

.coupon-section button:hover {
  background: var(--brand);
  color: white;
  border-color: var(--brand);
  box-shadow: 0 3px 10px var(--brand-glow);
}

/* ======================================
   PLACE ORDER BUTTON
====================================== */
.continue-button {
  width: 100%;
  padding: 14px 0;
  background: linear-gradient(135deg, var(--orange), var(--orange-deep));
  color: white;
  border: none;
  border-radius: var(--radius-md);
  font-family: var(--font);
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: 0 4px 16px var(--orange-glow);
  transition: all 0.25s var(--ease);
  margin-top: 6px;
}

.continue-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px var(--orange-glow);
  background: linear-gradient(135deg, #E64A19, #BF360C);
}

/* ======================================
   LOADING STATE
====================================== */
.loading-container-cart {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background: var(--surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  gap: 16px;
  text-align: center;
}

.loading-spinner-cart {
  border: 4px solid var(--brand-soft);
  border-top: 4px solid var(--brand);
  border-radius: 50%;
  width: 44px;
  height: 44px;
  animation: spin 0.85s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-container-cart p {
  font-family: var(--font);
  font-size: 14px;
  font-weight: 500;
  color: var(--text-muted);
  margin: 0;
}

/* ======================================
   EMPTY CART
====================================== */
.empty-cart {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background: var(--surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  text-align: center;
  gap: 10px;
}

.empty-cart img { width: 140px; opacity: 0.7; margin-bottom: 6px; }

.empty-cart h3 {
  font-family: var(--font);
  font-size: 18px;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0;
}

.empty-cart p {
  font-size: 13.5px;
  color: var(--text-muted);
  margin: 0;
  line-height: 1.55;
  max-width: 300px;
}

.empty-cart-button {
  margin-top: 8px;
  padding: 11px 28px;
  background: linear-gradient(135deg, var(--brand), var(--brand-mid));
  color: white;
  border: none;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 3px 12px var(--brand-glow);
  transition: all 0.2s var(--ease);
}

.empty-cart-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px var(--brand-glow);
}

/* ======================================
   REMOVE CONFIRMATION MODAL
====================================== */
.popup-overlay,
.popup-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(13, 27, 42, 0.55);
  backdrop-filter: blur(6px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-modal {
  background: var(--surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-strong);
  min-width: 320px;
  max-width: 90vw;
  text-align: center;
  overflow: hidden;
  animation: modalIn 0.25s var(--ease);
  z-index: 10000;
  padding: 0;
}

@keyframes modalIn {
  from { opacity: 0; transform: scale(0.95) translateY(12px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}

.popup-modal::before {
  content: '';
  display: block;
  height: 4px;
  background: linear-gradient(90deg, var(--danger), #FF8A80);
}

.popup-modal h3 {
  font-family: var(--font);
  font-size: 17px;
  font-weight: 800;
  color: var(--text-primary);
  padding: 20px 28px 6px;
  margin: 0;
}

.popup-modal p {
  font-family: var(--font);
  font-size: 13.5px;
  color: var(--text-muted);
  padding: 0 28px 18px;
  margin: 0;
  line-height: 1.6;
}

.popup-modal > div:last-child {
  display: flex;
  gap: 10px;
  justify-content: center;
  padding: 4px 24px 24px;
}

.confirm-remove-btn,
.confirm-btn {
  padding: 9px 24px;
  background: var(--danger);
  color: white;
  border: none;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(239,68,68,0.3);
  transition: all 0.18s var(--ease);
}

.confirm-remove-btn:hover,
.confirm-btn:hover {
  background: #DC2626;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(239,68,68,0.35);
}

.cancel-remove-btn,
.cancel-btn {
  padding: 9px 22px;
  background: var(--surface-2);
  color: var(--text-secondary);
  border: 1.5px solid var(--border-strong);
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.18s var(--ease);
}

.cancel-remove-btn:hover,
.cancel-btn:hover {
  background: var(--border);
  color: var(--text-primary);
}

.cart-icon-wrapper { position: relative; display: inline-block; }

/* ======================================
   MOBILE BOTTOM BAR — Flipkart Style
   Fixed checkout bar at bottom on mobile
====================================== */
.mobile-checkout-bar {
  display: none;
}

/* ======================================
   RESPONSIVE — TABLET
====================================== */
@media (max-width: 900px) {
  .cart {
    padding: 24px 14px 100px; /* bottom padding for fixed checkout bar */
  }

  .cart-content {
    flex-direction: column;
    gap: 12px;
  }

  .price-summary {
    position: static;
    /* Hide full summary on mobile — show only bottom bar */
    border-radius: var(--radius-md);
  }
}

/* ======================================
   RESPONSIVE — MOBILE (Flipkart Style)
====================================== */
@media (max-width: 768px) {

  /* ── Page shell ── */
  .cart {
    margin: 70px 0 0;
    padding: 0 0 90px;
    background: #f1f3f6;
    max-width: 100%;
    width: 100%;
  }

  /* ── TOP LAYOUT: stack items above price summary, both full width ── */
  .cart-content {
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }

  /* ── Header ── */
  .cart-header {
    border-radius: 0;
    margin-bottom: 8px;
    padding: 12px 16px;
    border-left: none;
    border-right: none;
    border-top: none;
    box-shadow: 0 1px 4px rgba(0,0,0,0.08);
    width: 100%;
  }

  .cart-header::before { display: none; }

  .cart-header h2 {
    font-size: 14px;
    padding-left: 0;
    color: var(--text-primary);
  }

  .delivery-info { font-size: 12px; }

  /* ── Items container — full width ── */
  .cart-items-container {
    width: 100%;
    border-radius: 0;
    border-left: none;
    border-right: none;
    box-shadow: none;
    background: transparent;
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: unset; /* override flex:2 */
  }

  /* ── Each cart item — horizontal row (image left, content right) ── */
  .cart-item-card {
    background: var(--surface);
    border-radius: 0;
    border: none;
    border-bottom: 8px solid #f1f3f6;
    margin: 0;
    padding: 14px 16px 14px;
    gap: 12px;
    flex-direction: row;       /* ← KEY: image LEFT, details RIGHT */
    align-items: flex-start;
    box-shadow: none;
    position: relative;
    width: 100%;
  }

  .cart-item-card:last-child { border-bottom: none; }

  /* ── Checkbox ── */
  .item-selector {
    padding-top: 4px;
    flex-shrink: 0;
  }

  .item-selector input[type="checkbox"],
  .item-selector input {
    width: 16px;
    height: 16px;
  }

  /* ── Product image — fixed square on left ── */
  .cart-item-image {
    width: 90px;
    height: 90px;
    min-width: 90px;     /* prevents shrinking */
    flex-shrink: 0;
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
    background: var(--surface-2);
    padding: 6px;
    object-fit: contain;
    align-self: flex-start;
  }

  /* ── Details column — fills rest of row on RIGHT ── */
  .cart-item-details {
    flex: 1 1;
    padding-right: 0;
    min-width: 0;        /* allows text truncation */
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  /* Product name — 2 lines max, space for remove btn */
  .cart-item-details h3 {
    font-size: 13.5px;
    font-weight: 600;
    color: var(--text-primary);
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin: 0 0 2px;
    padding-right: 56px; /* space for REMOVE button */
  }

  .seller-info {
    font-size: 11.5px;
    color: var(--text-muted);
    margin-bottom: 4px;
  }

  /* ── Price row ── */
  .price-details {
    gap: 5px;
    margin: 3px 0 6px;
    flex-wrap: wrap;
    align-items: baseline;
  }

  .current-price {
    font-size: 15px;
    font-weight: 800;
  }

  .original-price {
    font-size: 12px;
    margin-left: 2px;
  }

  .discount-percent {
    font-size: 11px;
    padding: 2px 6px;
  }

  /* ── Delivery info ── */
  .delivery-icon { font-size: 12px; }

  .delivery-date {
    font-size: 11.5px;
    font-weight: 600;
  }

  /* ── Quantity controls ── */
  .quantity-controls {
    margin-top: 8px;
    border-radius: 6px;
    border: 1.5px solid #d0d0d0;
    display: inline-flex;
    width: fit-content;
  }

  .quantity-controls button {
    width: 30px;
    height: 28px;
    font-size: 16px;
    color: var(--brand);
  }

  .quantity-controls span {
    width: 32px;
    height: 28px;
    font-size: 13px;
    border-left: 1.5px solid #d0d0d0;
    border-right: 1.5px solid #d0d0d0;
  }

  /* ── Remove button — top-right of card ── */
  .remove-button {
    position: absolute;
    top: 14px;
    right: 14px;
    font-size: 10px;
    padding: 3px 9px;
    letter-spacing: 0.2px;
    border-radius: 6px;
    border: 1px solid #e0e0e0;
    background: #f5f5f5;
    color: #777;
    white-space: nowrap;
  }

  .remove-button:hover {
    background: var(--danger-soft);
    border-color: #FECACA;
    color: var(--danger);
  }

  /* ── Price Summary — FULL WIDTH ── */
  .price-summary {
    width: 100%;           /* full screen width */
    flex: unset;           /* override flex:1 */
    margin: 0;
    border-radius: 0;
    border-left: none;
    border-right: none;
    padding: 16px;
    position: static;
    box-shadow: none;
    border-top: 8px solid #f1f3f6;
    border-bottom: none;
  }

  .price-summary::before {
    margin: -16px -16px 14px;
    height: 3px;
  }

  .price-summary-header {
    font-size: 10.5px;
    letter-spacing: 1px;
    padding-bottom: 12px;
    margin-bottom: 12px;
  }

  .price-detail-row {
    font-size: 13px;
    margin-bottom: 10px;
  }

  .price-detail-row.total {
    font-size: 15px;
    padding-top: 12px;
  }

  .savings-message {
    font-size: 12.5px;
    padding: 8px 12px;
    margin: 10px 0;
  }

  /* ── Coupon — stacked full width ── */
  .coupon-section {
    flex-direction: column;
    gap: 8px;
    margin-bottom: 14px;
  }

  .coupon-section input[type="text"],
  .coupon-section button {
    width: 100%;
    margin-top: 0;
  }

  .coupon-section button {
    padding: 10px 16px;
    font-size: 13px;
    text-align: center;
  }

  /* ── Place Order button — hidden, shown in bottom bar instead ── */
  .continue-button {
    display: none;
  }

  /* ══════════════════════════════════
     FIXED BOTTOM CHECKOUT BAR
  ══════════════════════════════════ */
  .mobile-checkout-bar {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 500;
    background: var(--surface);
    border-top: 1.5px solid var(--border);
    padding: 10px 16px;
    gap: 12px;
    align-items: center;
    box-shadow: 0 -4px 20px rgba(21,101,192,0.12);
  }

  .mobile-checkout-total {
    flex: 1 1;
    min-width: 0;
  }

  .mobile-checkout-total .total-label {
    font-size: 11px;
    color: var(--text-muted);
    font-weight: 500;
    display: block;
    line-height: 1;
    margin-bottom: 2px;
  }

  .mobile-checkout-total .total-amount {
    font-size: 18px;
    font-weight: 800;
    color: var(--text-primary);
    display: block;
    letter-spacing: -0.5px;
    line-height: 1.2;
  }

  .mobile-checkout-total .total-savings {
    font-size: 11px;
    color: var(--success);
    font-weight: 700;
    display: block;
    margin-top: 1px;
  }

  .mobile-place-order-btn {
    flex-shrink: 0;
    padding: 13px 28px;
    background: linear-gradient(135deg, var(--orange), var(--orange-deep));
    color: white;
    border: none;
    border-radius: var(--radius-sm);
    font-family: var(--font);
    font-size: 14px;
    font-weight: 800;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    cursor: pointer;
    box-shadow: 0 3px 12px var(--orange-glow);
    transition: all 0.2s var(--ease);
    white-space: nowrap;
  }

  .mobile-place-order-btn:active {
    transform: scale(0.97);
    box-shadow: 0 1px 6px var(--orange-glow);
  }

  /* ── Full message banner ── */
  .cart-full-message {
    margin: 0;
    border-radius: 0;
    border-left: none;
    border-right: none;
  }
}

/* ======================================
   RESPONSIVE — SMALL PHONES
====================================== */
@media (max-width: 380px) {
  .cart-item-image {
    width: 76px;
    height: 76px;
  }

  .cart-item-details h3 { font-size: 13px; }
  .current-price        { font-size: 14px; }
  .mobile-place-order-btn { padding: 12px 20px; font-size: 13px; }
  .mobile-checkout-total .total-amount { font-size: 16px; }

  .cart-item-card { padding: 12px; gap: 10px; }
}`, "",{"version":3,"sources":["webpack://./src/components/Cart.css"],"names":[],"mappings":"AAEA;;wCAEwC;AACxC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;EACzC,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,iDAAiD;EACjD,+CAA+C;EAC/C,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,mFAAmF;EACnF,qFAAqF;EACrF,qFAAqF;AACvF;;AAEA,IAAI,sBAAsB,EAAE;;AAE5B;;wCAEwC;AACxC;EACE,wBAAwB;EACxB,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;wCAEwC;AACxC;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO,EAAE,MAAM,EAAE,SAAS;EAC1B,UAAU;EACV,qEAAqE;EACrE,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;;wCAEwC;AACxC;EACE,SAAO;EACP,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA,6BAA6B,mBAAmB,EAAE;AAClD,wBAAwB,4BAA4B,EAAE;;AAEtD;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,YAAY;EACZ,cAAc;EACd,uCAAuC;AACzC;;AAEA,yCAAyC,sBAAsB,EAAE;;AAEjE;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,iBAAiB,eAAe,EAAE;;AAElC;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;wCAEwC;AACxC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,kCAAkC,6BAA6B,EAAE;;AAEjE;EACE,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;wCAEwC;AACxC;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,uBAAuB;EACvB,wCAAwC;EACxC,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;wCAEwC;AACxC;EACE,SAAO;EACP,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,mFAAmF;EACnF,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,2CAA2C;EAC3C,eAAe;EACf,sBAAsB;AACxB;;AAEA,YAAY,qBAAqB,EAAE,gBAAgB,EAAE;AACrD,iBAAiB,qBAAqB,EAAE,gBAAgB,EAAE;;AAE1D;EACE,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,kBAAkB;AACpB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,wCAAwC;EACxC,+BAA+B;EAC/B,wBAAwB;EACxB,iBAAiB;EACjB,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;EACb,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,wCAAwC;EACxC,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;;wCAEwC;AACxC;EACE,WAAW;EACX,eAAe;EACf,sEAAsE;EACtE,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,yCAAyC;EACzC,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;AACX;;AAEA,kBAAkB,YAAY,EAAE,YAAY,EAAE,kBAAkB,EAAE;;AAElE;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mEAAmE;EACnE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;;wCAEwC;AACxC;;EAEE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,0DAA0D;AAC5D;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;;EAEE,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;;EAEE,iBAAiB;EACjB,4BAA4B;EAC5B,4BAA4B;EAC5B,wCAAwC;EACxC,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,qBAAqB,kBAAkB,EAAE,qBAAqB,EAAE;;AAEhE;;;wCAGwC;AACxC;EACE,aAAa;AACf;;AAEA;;wCAEwC;AACxC;EACE;IACE,wBAAwB,EAAE,0CAA0C;EACtE;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,uDAAuD;IACvD,+BAA+B;EACjC;AACF;;AAEA;;wCAEwC;AACxC;;EAEE,qBAAqB;EACrB;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA,uEAAuE;EACvE;IACE,sBAAsB;IACtB,QAAQ;IACR,WAAW;EACb;;EAEA,iBAAiB;EACjB;IACE,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,sCAAsC;IACtC,WAAW;EACb;;EAEA,uBAAuB,aAAa,EAAE;;EAEtC;IACE,eAAe;IACf,eAAe;IACf,0BAA0B;EAC5B;;EAEA,iBAAiB,eAAe,EAAE;;EAElC,uCAAuC;EACvC;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW,EAAE,oBAAoB;EACnC;;EAEA,sEAAsE;EACtE;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,SAAS;IACT,uBAAuB;IACvB,SAAS;IACT,mBAAmB,QAAQ,qCAAqC;IAChE,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;EACb;;EAEA,6BAA6B,mBAAmB,EAAE;;EAElD,mBAAmB;EACnB;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA,+CAA+C;EAC/C;IACE,WAAW;IACX,YAAY;IACZ,eAAe,MAAM,uBAAuB;IAC5C,cAAc;IACd,+BAA+B;IAC/B,+BAA+B;IAC/B,4BAA4B;IAC5B,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA,sDAAsD;EACtD;IACE,SAAO;IACP,gBAAgB;IAChB,YAAY,SAAS,2BAA2B;IAChD,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA,qDAAqD;EACrD;IACE,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,mBAAmB,EAAE,4BAA4B;EACnD;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA,oBAAoB;EACpB;IACE,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,wBAAwB;EACxB,iBAAiB,eAAe,EAAE;;EAElC;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,4BAA4B;EAC5B;IACE,eAAe;IACf,kBAAkB;IAClB,2BAA2B;IAC3B,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gCAAgC;IAChC,iCAAiC;EACnC;;EAEA,4CAA4C;EAC5C;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA,qCAAqC;EACrC;IACE,WAAW,YAAY,sBAAsB;IAC7C,WAAW,YAAY,oBAAoB;IAC3C,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;EAChB;;EAEA,sCAAsC;EACtC;IACE,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;;EAEA,mEAAmE;EACnE;IACE,aAAa;EACf;;EAEA;;sCAEoC;EACpC;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,0BAA0B;IAC1B,qCAAqC;IACrC,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,6CAA6C;EAC/C;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,sEAAsE;IACtE,YAAY;IACZ,YAAY;IACZ,+BAA+B;IAC/B,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;IACf,yCAAyC;IACzC,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA,8BAA8B;EAC9B;IACE,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;;wCAEwC;AACxC;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA,wBAAwB,eAAe,EAAE;EACzC,wBAAwB,eAAe,EAAE;EACzC,0BAA0B,kBAAkB,EAAE,eAAe,EAAE;EAC/D,uCAAuC,eAAe,EAAE;;EAExD,kBAAkB,aAAa,EAAE,SAAS,EAAE;AAC9C","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');\n\n/* ======================================\n   DESIGN TOKENS — Pyate Blue Brand\n====================================== */\n:root {\n  --brand:          #1565C0;\n  --brand-mid:      #1976D2;\n  --brand-light:    #42A5F5;\n  --brand-soft:     #E3F2FD;\n  --brand-glow:     rgba(21, 101, 192, 0.18);\n  --orange:         #F4511E;\n  --orange-deep:    #D84315;\n  --orange-soft:    #FBE9E7;\n  --orange-glow:    rgba(244, 81, 30, 0.24);\n  --accent:         #00BCD4;\n  --surface:        #ffffff;\n  --surface-2:      #F8FAFC;\n  --surface-3:      #EEF4FB;\n  --bg:             #EEF4FB;\n  --border:         #DBEAFE;\n  --border-strong:  #BFDBFE;\n  --text-primary:   #0D1B2A;\n  --text-secondary: #3B5270;\n  --text-muted:     #7A96B2;\n  --danger:         #EF4444;\n  --danger-soft:    #FEF2F2;\n  --success:        #22C55E;\n  --success-soft:   #DCFCE7;\n  --font:           'Plus Jakarta Sans', sans-serif;\n  --ease:           cubic-bezier(0.16, 1, 0.3, 1);\n  --radius-sm:      8px;\n  --radius-md:      14px;\n  --radius-lg:      20px;\n  --shadow-sm:      0 1px 4px rgba(21,101,192,0.07), 0 4px 14px rgba(21,101,192,0.05);\n  --shadow-md:      0 4px 20px rgba(21,101,192,0.12), 0 12px 36px rgba(21,101,192,0.07);\n  --shadow-lg:      0 8px 36px rgba(21,101,192,0.16), 0 28px 60px rgba(21,101,192,0.09);\n}\n\n* { box-sizing: border-box; }\n\n/* ======================================\n   CART PAGE WRAPPER\n====================================== */\n.cart {\n  font-family: var(--font);\n  max-width: 1200px;\n  margin: 70px auto 60px;\n  background: var(--bg);\n  padding: 28px 20px 30px;\n}\n\n/* ======================================\n   CART HEADER\n====================================== */\n.cart-header {\n  background: var(--surface);\n  padding: 14px 22px;\n  margin-bottom: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n  position: relative;\n  overflow: hidden;\n}\n\n.cart-header::before {\n  content: '';\n  position: absolute;\n  left: 0; top: 0; bottom: 0;\n  width: 4px;\n  background: linear-gradient(180deg, var(--brand), var(--brand-light));\n  border-radius: var(--radius-md) 0 0 var(--radius-md);\n}\n\n.cart-header h2 {\n  font-size: 15px;\n  font-weight: 800;\n  color: var(--brand);\n  margin: 0;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  padding-left: 6px;\n}\n\n.delivery-info {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 13px;\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n/* ======================================\n   LAYOUT\n====================================== */\n.cart-content {\n  display: flex;\n  gap: 18px;\n  align-items: flex-start;\n}\n\n/* ======================================\n   ITEMS PANEL\n====================================== */\n.cart-items-container {\n  flex: 2;\n  background: var(--surface);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n}\n\n.cart-full-message {\n  background: #FFF8E1;\n  color: #E65100;\n  padding: 10px 20px;\n  font-size: 13px;\n  font-weight: 600;\n  text-align: center;\n  border-bottom: 1px solid #FFE0B2;\n}\n\n/* ======================================\n   CART ITEM CARD\n====================================== */\n.cart-item-card {\n  display: flex;\n  padding: 20px 22px;\n  border-bottom: 1px solid var(--border);\n  position: relative;\n  gap: 14px;\n  align-items: flex-start;\n  transition: background 0.18s;\n}\n\n.cart-item-card:last-child { border-bottom: none; }\n.cart-item-card:hover { background: var(--surface-2); }\n\n.item-selector {\n  display: flex;\n  align-items: flex-start;\n  padding-top: 6px;\n  flex-shrink: 0;\n}\n\n.item-selector input[type=\"checkbox\"],\n.item-selector input {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--brand);\n  cursor: pointer;\n}\n\n.cart-item-image {\n  width: 86px;\n  height: 86px;\n  object-fit: contain;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  background: var(--surface-2);\n  padding: 8px;\n  flex-shrink: 0;\n  transition: transform 0.22s var(--ease);\n}\n\n.cart-item-card:hover .cart-item-image { transform: scale(1.05); }\n\n.cart-item-details {\n  flex-grow: 1;\n  padding-right: 80px;\n  min-width: 0;\n}\n\n.cart-item-details h3 {\n  font-size: 14.5px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 4px;\n  line-height: 1.4;\n}\n\n.seller-info {\n  font-size: 12px;\n  color: var(--text-muted);\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.price-details {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 6px 0;\n  flex-wrap: wrap;\n}\n\n.current-price {\n  font-size: 16px;\n  font-weight: 800;\n  color: var(--text-primary);\n  letter-spacing: -0.3px;\n}\n\n.original-price {\n  font-size: 13px;\n  color: var(--text-muted);\n  text-decoration: line-through;\n  margin-left: 4px;\n}\n\n.discount-percent {\n  font-size: 12px;\n  color: var(--success);\n  font-weight: 700;\n  background: var(--success-soft);\n  padding: 2px 8px;\n  border-radius: 100px;\n}\n\n.delivery-icon { font-size: 15px; }\n\n.delivery-date {\n  font-weight: 700;\n  color: var(--brand);\n}\n\n/* ======================================\n   QUANTITY CONTROLS\n====================================== */\n.quantity-controls {\n  display: inline-flex;\n  align-items: center;\n  margin: 12px 0 0;\n  border: 1.5px solid var(--border-strong);\n  border-radius: 100px;\n  overflow: hidden;\n  background: var(--surface);\n  box-shadow: var(--shadow-sm);\n}\n\n.quantity-controls button {\n  background: transparent;\n  border: none;\n  width: 34px;\n  height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--brand);\n  transition: background 0.15s;\n  flex-shrink: 0;\n}\n\n.quantity-controls button:hover { background: var(--brand-soft); }\n\n.quantity-controls span {\n  width: 38px;\n  height: 34px;\n  border-left: 1.5px solid var(--border-strong);\n  border-right: 1.5px solid var(--border-strong);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n/* ======================================\n   REMOVE BUTTON\n====================================== */\n.remove-button {\n  position: absolute;\n  right: 20px;\n  top: 20px;\n  font-size: 11.5px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  cursor: pointer;\n  background: transparent;\n  border: 1.5px solid var(--border-strong);\n  color: var(--text-muted);\n  border-radius: 100px;\n  padding: 4px 12px;\n  transition: all 0.18s var(--ease);\n}\n\n.remove-button:hover {\n  background: var(--danger-soft);\n  border-color: #FECACA;\n  color: var(--danger);\n}\n\n/* ======================================\n   PRICE SUMMARY PANEL\n====================================== */\n.price-summary {\n  flex: 1;\n  background: var(--surface);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n  padding: 20px;\n  height: fit-content;\n  position: sticky;\n  top: 100px;\n  overflow: hidden;\n}\n\n.price-summary::before {\n  content: '';\n  display: block;\n  height: 4px;\n  background: linear-gradient(90deg, var(--brand), var(--brand-light), var(--accent));\n  margin: -20px -20px 18px;\n}\n\n.price-summary-header {\n  font-size: 11px;\n  font-weight: 800;\n  color: var(--text-muted);\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  padding-bottom: 14px;\n  border-bottom: 1px solid var(--border);\n  margin-bottom: 16px;\n}\n\n.price-detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 13px;\n  font-size: 14px;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.price-detail-row.total {\n  font-weight: 800;\n  font-size: 17px;\n  color: var(--text-primary);\n  padding-top: 14px;\n  border-top: 1px dashed var(--border-strong);\n  margin-top: 4px;\n  letter-spacing: -0.3px;\n}\n\n.discount { color: var(--success); font-weight: 700; }\n.free-delivery { color: var(--success); font-weight: 700; }\n\n.savings-message {\n  background: var(--success-soft);\n  color: #15803D;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 10px 14px;\n  border-radius: var(--radius-sm);\n  margin: 14px 0;\n  text-align: center;\n}\n\n/* ======================================\n   COUPON SECTION\n====================================== */\n.coupon-section {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 16px;\n  align-items: center;\n}\n\n.coupon-section input[type=\"text\"] {\n  flex: 1;\n  padding: 9px 14px;\n  border: 1.5px solid var(--border-strong);\n  border-radius: var(--radius-sm);\n  font-family: var(--font);\n  font-size: 13.5px;\n  color: var(--text-primary);\n  background: var(--surface-2);\n  outline: none;\n  min-width: 0;\n  transition: border-color 0.18s, box-shadow 0.18s;\n}\n\n.coupon-section input[type=\"text\"]:focus {\n  border-color: var(--brand-mid);\n  box-shadow: 0 0 0 3px var(--brand-soft);\n  background: white;\n}\n\n.coupon-section button {\n  padding: 9px 16px;\n  background: var(--brand-soft);\n  color: var(--brand);\n  border: 1.5px solid var(--border-strong);\n  border-radius: var(--radius-sm);\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  margin-top: 0;\n  transition: all 0.18s var(--ease);\n}\n\n.coupon-section button:hover {\n  background: var(--brand);\n  color: white;\n  border-color: var(--brand);\n  box-shadow: 0 3px 10px var(--brand-glow);\n}\n\n/* ======================================\n   PLACE ORDER BUTTON\n====================================== */\n.continue-button {\n  width: 100%;\n  padding: 14px 0;\n  background: linear-gradient(135deg, var(--orange), var(--orange-deep));\n  color: white;\n  border: none;\n  border-radius: var(--radius-md);\n  font-family: var(--font);\n  font-size: 15px;\n  font-weight: 800;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  cursor: pointer;\n  box-shadow: 0 4px 16px var(--orange-glow);\n  transition: all 0.25s var(--ease);\n  margin-top: 6px;\n}\n\n.continue-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px var(--orange-glow);\n  background: linear-gradient(135deg, #E64A19, #BF360C);\n}\n\n/* ======================================\n   LOADING STATE\n====================================== */\n.loading-container-cart {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  background: var(--surface);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border);\n  gap: 16px;\n  text-align: center;\n}\n\n.loading-spinner-cart {\n  border: 4px solid var(--brand-soft);\n  border-top: 4px solid var(--brand);\n  border-radius: 50%;\n  width: 44px;\n  height: 44px;\n  animation: spin 0.85s linear infinite;\n  margin: 0 auto;\n}\n\n@keyframes spin {\n  0%   { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-container-cart p {\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-muted);\n  margin: 0;\n}\n\n/* ======================================\n   EMPTY CART\n====================================== */\n.empty-cart {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  background: var(--surface);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n  text-align: center;\n  gap: 10px;\n}\n\n.empty-cart img { width: 140px; opacity: 0.7; margin-bottom: 6px; }\n\n.empty-cart h3 {\n  font-family: var(--font);\n  font-size: 18px;\n  font-weight: 800;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.empty-cart p {\n  font-size: 13.5px;\n  color: var(--text-muted);\n  margin: 0;\n  line-height: 1.55;\n  max-width: 300px;\n}\n\n.empty-cart-button {\n  margin-top: 8px;\n  padding: 11px 28px;\n  background: linear-gradient(135deg, var(--brand), var(--brand-mid));\n  color: white;\n  border: none;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13.5px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 3px 12px var(--brand-glow);\n  transition: all 0.2s var(--ease);\n}\n\n.empty-cart-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px var(--brand-glow);\n}\n\n/* ======================================\n   REMOVE CONFIRMATION MODAL\n====================================== */\n.popup-overlay,\n.popup-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(13, 27, 42, 0.55);\n  backdrop-filter: blur(6px);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.popup-modal {\n  background: var(--surface);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--border-strong);\n  min-width: 320px;\n  max-width: 90vw;\n  text-align: center;\n  overflow: hidden;\n  animation: modalIn 0.25s var(--ease);\n  z-index: 10000;\n  padding: 0;\n}\n\n@keyframes modalIn {\n  from { opacity: 0; transform: scale(0.95) translateY(12px); }\n  to   { opacity: 1; transform: scale(1) translateY(0); }\n}\n\n.popup-modal::before {\n  content: '';\n  display: block;\n  height: 4px;\n  background: linear-gradient(90deg, var(--danger), #FF8A80);\n}\n\n.popup-modal h3 {\n  font-family: var(--font);\n  font-size: 17px;\n  font-weight: 800;\n  color: var(--text-primary);\n  padding: 20px 28px 6px;\n  margin: 0;\n}\n\n.popup-modal p {\n  font-family: var(--font);\n  font-size: 13.5px;\n  color: var(--text-muted);\n  padding: 0 28px 18px;\n  margin: 0;\n  line-height: 1.6;\n}\n\n.popup-modal > div:last-child {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  padding: 4px 24px 24px;\n}\n\n.confirm-remove-btn,\n.confirm-btn {\n  padding: 9px 24px;\n  background: var(--danger);\n  color: white;\n  border: none;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(239,68,68,0.3);\n  transition: all 0.18s var(--ease);\n}\n\n.confirm-remove-btn:hover,\n.confirm-btn:hover {\n  background: #DC2626;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 14px rgba(239,68,68,0.35);\n}\n\n.cancel-remove-btn,\n.cancel-btn {\n  padding: 9px 22px;\n  background: var(--surface-2);\n  color: var(--text-secondary);\n  border: 1.5px solid var(--border-strong);\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.18s var(--ease);\n}\n\n.cancel-remove-btn:hover,\n.cancel-btn:hover {\n  background: var(--border);\n  color: var(--text-primary);\n}\n\n.cart-icon-wrapper { position: relative; display: inline-block; }\n\n/* ======================================\n   MOBILE BOTTOM BAR — Flipkart Style\n   Fixed checkout bar at bottom on mobile\n====================================== */\n.mobile-checkout-bar {\n  display: none;\n}\n\n/* ======================================\n   RESPONSIVE — TABLET\n====================================== */\n@media (max-width: 900px) {\n  .cart {\n    padding: 24px 14px 100px; /* bottom padding for fixed checkout bar */\n  }\n\n  .cart-content {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .price-summary {\n    position: static;\n    /* Hide full summary on mobile — show only bottom bar */\n    border-radius: var(--radius-md);\n  }\n}\n\n/* ======================================\n   RESPONSIVE — MOBILE (Flipkart Style)\n====================================== */\n@media (max-width: 768px) {\n\n  /* ── Page shell ── */\n  .cart {\n    margin: 70px 0 0;\n    padding: 0 0 90px;\n    background: #f1f3f6;\n    max-width: 100%;\n    width: 100%;\n  }\n\n  /* ── TOP LAYOUT: stack items above price summary, both full width ── */\n  .cart-content {\n    flex-direction: column;\n    gap: 8px;\n    width: 100%;\n  }\n\n  /* ── Header ── */\n  .cart-header {\n    border-radius: 0;\n    margin-bottom: 8px;\n    padding: 12px 16px;\n    border-left: none;\n    border-right: none;\n    border-top: none;\n    box-shadow: 0 1px 4px rgba(0,0,0,0.08);\n    width: 100%;\n  }\n\n  .cart-header::before { display: none; }\n\n  .cart-header h2 {\n    font-size: 14px;\n    padding-left: 0;\n    color: var(--text-primary);\n  }\n\n  .delivery-info { font-size: 12px; }\n\n  /* ── Items container — full width ── */\n  .cart-items-container {\n    width: 100%;\n    border-radius: 0;\n    border-left: none;\n    border-right: none;\n    box-shadow: none;\n    background: transparent;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    flex: unset; /* override flex:2 */\n  }\n\n  /* ── Each cart item — horizontal row (image left, content right) ── */\n  .cart-item-card {\n    background: var(--surface);\n    border-radius: 0;\n    border: none;\n    border-bottom: 8px solid #f1f3f6;\n    margin: 0;\n    padding: 14px 16px 14px;\n    gap: 12px;\n    flex-direction: row;       /* ← KEY: image LEFT, details RIGHT */\n    align-items: flex-start;\n    box-shadow: none;\n    position: relative;\n    width: 100%;\n  }\n\n  .cart-item-card:last-child { border-bottom: none; }\n\n  /* ── Checkbox ── */\n  .item-selector {\n    padding-top: 4px;\n    flex-shrink: 0;\n  }\n\n  .item-selector input[type=\"checkbox\"],\n  .item-selector input {\n    width: 16px;\n    height: 16px;\n  }\n\n  /* ── Product image — fixed square on left ── */\n  .cart-item-image {\n    width: 90px;\n    height: 90px;\n    min-width: 90px;     /* prevents shrinking */\n    flex-shrink: 0;\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--border);\n    background: var(--surface-2);\n    padding: 6px;\n    object-fit: contain;\n    align-self: flex-start;\n  }\n\n  /* ── Details column — fills rest of row on RIGHT ── */\n  .cart-item-details {\n    flex: 1;\n    padding-right: 0;\n    min-width: 0;        /* allows text truncation */\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  /* Product name — 2 lines max, space for remove btn */\n  .cart-item-details h3 {\n    font-size: 13.5px;\n    font-weight: 600;\n    color: var(--text-primary);\n    line-height: 1.4;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    margin: 0 0 2px;\n    padding-right: 56px; /* space for REMOVE button */\n  }\n\n  .seller-info {\n    font-size: 11.5px;\n    color: var(--text-muted);\n    margin-bottom: 4px;\n  }\n\n  /* ── Price row ── */\n  .price-details {\n    gap: 5px;\n    margin: 3px 0 6px;\n    flex-wrap: wrap;\n    align-items: baseline;\n  }\n\n  .current-price {\n    font-size: 15px;\n    font-weight: 800;\n  }\n\n  .original-price {\n    font-size: 12px;\n    margin-left: 2px;\n  }\n\n  .discount-percent {\n    font-size: 11px;\n    padding: 2px 6px;\n  }\n\n  /* ── Delivery info ── */\n  .delivery-icon { font-size: 12px; }\n\n  .delivery-date {\n    font-size: 11.5px;\n    font-weight: 600;\n  }\n\n  /* ── Quantity controls ── */\n  .quantity-controls {\n    margin-top: 8px;\n    border-radius: 6px;\n    border: 1.5px solid #d0d0d0;\n    display: inline-flex;\n    width: fit-content;\n  }\n\n  .quantity-controls button {\n    width: 30px;\n    height: 28px;\n    font-size: 16px;\n    color: var(--brand);\n  }\n\n  .quantity-controls span {\n    width: 32px;\n    height: 28px;\n    font-size: 13px;\n    border-left: 1.5px solid #d0d0d0;\n    border-right: 1.5px solid #d0d0d0;\n  }\n\n  /* ── Remove button — top-right of card ── */\n  .remove-button {\n    position: absolute;\n    top: 14px;\n    right: 14px;\n    font-size: 10px;\n    padding: 3px 9px;\n    letter-spacing: 0.2px;\n    border-radius: 6px;\n    border: 1px solid #e0e0e0;\n    background: #f5f5f5;\n    color: #777;\n    white-space: nowrap;\n  }\n\n  .remove-button:hover {\n    background: var(--danger-soft);\n    border-color: #FECACA;\n    color: var(--danger);\n  }\n\n  /* ── Price Summary — FULL WIDTH ── */\n  .price-summary {\n    width: 100%;           /* full screen width */\n    flex: unset;           /* override flex:1 */\n    margin: 0;\n    border-radius: 0;\n    border-left: none;\n    border-right: none;\n    padding: 16px;\n    position: static;\n    box-shadow: none;\n    border-top: 8px solid #f1f3f6;\n    border-bottom: none;\n  }\n\n  .price-summary::before {\n    margin: -16px -16px 14px;\n    height: 3px;\n  }\n\n  .price-summary-header {\n    font-size: 10.5px;\n    letter-spacing: 1px;\n    padding-bottom: 12px;\n    margin-bottom: 12px;\n  }\n\n  .price-detail-row {\n    font-size: 13px;\n    margin-bottom: 10px;\n  }\n\n  .price-detail-row.total {\n    font-size: 15px;\n    padding-top: 12px;\n  }\n\n  .savings-message {\n    font-size: 12.5px;\n    padding: 8px 12px;\n    margin: 10px 0;\n  }\n\n  /* ── Coupon — stacked full width ── */\n  .coupon-section {\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 14px;\n  }\n\n  .coupon-section input[type=\"text\"],\n  .coupon-section button {\n    width: 100%;\n    margin-top: 0;\n  }\n\n  .coupon-section button {\n    padding: 10px 16px;\n    font-size: 13px;\n    text-align: center;\n  }\n\n  /* ── Place Order button — hidden, shown in bottom bar instead ── */\n  .continue-button {\n    display: none;\n  }\n\n  /* ══════════════════════════════════\n     FIXED BOTTOM CHECKOUT BAR\n  ══════════════════════════════════ */\n  .mobile-checkout-bar {\n    display: flex;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 500;\n    background: var(--surface);\n    border-top: 1.5px solid var(--border);\n    padding: 10px 16px;\n    gap: 12px;\n    align-items: center;\n    box-shadow: 0 -4px 20px rgba(21,101,192,0.12);\n  }\n\n  .mobile-checkout-total {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .mobile-checkout-total .total-label {\n    font-size: 11px;\n    color: var(--text-muted);\n    font-weight: 500;\n    display: block;\n    line-height: 1;\n    margin-bottom: 2px;\n  }\n\n  .mobile-checkout-total .total-amount {\n    font-size: 18px;\n    font-weight: 800;\n    color: var(--text-primary);\n    display: block;\n    letter-spacing: -0.5px;\n    line-height: 1.2;\n  }\n\n  .mobile-checkout-total .total-savings {\n    font-size: 11px;\n    color: var(--success);\n    font-weight: 700;\n    display: block;\n    margin-top: 1px;\n  }\n\n  .mobile-place-order-btn {\n    flex-shrink: 0;\n    padding: 13px 28px;\n    background: linear-gradient(135deg, var(--orange), var(--orange-deep));\n    color: white;\n    border: none;\n    border-radius: var(--radius-sm);\n    font-family: var(--font);\n    font-size: 14px;\n    font-weight: 800;\n    letter-spacing: 0.6px;\n    text-transform: uppercase;\n    cursor: pointer;\n    box-shadow: 0 3px 12px var(--orange-glow);\n    transition: all 0.2s var(--ease);\n    white-space: nowrap;\n  }\n\n  .mobile-place-order-btn:active {\n    transform: scale(0.97);\n    box-shadow: 0 1px 6px var(--orange-glow);\n  }\n\n  /* ── Full message banner ── */\n  .cart-full-message {\n    margin: 0;\n    border-radius: 0;\n    border-left: none;\n    border-right: none;\n  }\n}\n\n/* ======================================\n   RESPONSIVE — SMALL PHONES\n====================================== */\n@media (max-width: 380px) {\n  .cart-item-image {\n    width: 76px;\n    height: 76px;\n  }\n\n  .cart-item-details h3 { font-size: 13px; }\n  .current-price        { font-size: 14px; }\n  .mobile-place-order-btn { padding: 12px 20px; font-size: 13px; }\n  .mobile-checkout-total .total-amount { font-size: 16px; }\n\n  .cart-item-card { padding: 12px; gap: 10px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
